import { Directive,Component, OnInit } from '@angular/core';
import { NG_ASYNC_VALIDATORS, AsyncValidator, AbstractControl, ValidationErrors, AsyncValidatorFn } from '@angular/forms';
import { of ,Observable, pipe} from 'rxjs';
import { GenericVm } from '../system/generic-vm';
import { ConfigService } from '../../services/config.service';
import { HttpHeaders } from '@angular/common/http';
import { HttpRequestService } from '../../services/http-request.service';
import { map } from 'rxjs/operators';
import { resumeEvent } from 'tns-core-modules/application/application';


@Directive({
    selector: '[EmailExist][ngModel],[EmailExist][FormControl]',
    providers: [
        {provide: NG_ASYNC_VALIDATORS, useExisting: EmailExist, multi: true}
    ]
})
export class EmailExist implements AsyncValidator {
    config: any;
   
    globals: any;
    Exist:boolean;
    httpOptions: { headers: HttpHeaders; };

    constructor(private configService: ConfigService, private httRequest: HttpRequestService) {
        this.httpOptions = {
          headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        };
      }

    validate(control: AbstractControl):  Observable<ValidationErrors |null>{
        return this.httRequest.GetRequest('Accounts/EmailIsExist?email='+control.value)
          .pipe(
            map(res => {
              console.log((res as GenericVm<boolean>).data);
              if ( (res as GenericVm<boolean>).data) {
                // return error (key: value)
                return { 'Exist': true};
              }
              return null;
             
            })
          );
      }
     


   
  

 
}